import {string, func, any, object, bool} from 'prop-types';
import {forbidExtraProps} from 'airbnb-prop-types';
import {unionContexts, explicitNullOr} from 'r/utils';
import {twMerge} from 'tailwind-merge';

export default unionContexts(
  ButtonContainer,
);

ButtonContainer.propTypes = forbidExtraProps({
  children: any,
  className: string, // need for styled-components (when `const MyButton = styled(ButtonContainer)...`)
  disabled: bool,
  onClick: func,
  onMouseEnter: func,
  onMouseLeave: func,
  style: object,
  type: string,
  ref: explicitNullOr(object),
});

function ButtonContainer({
  children,
  className,
  disabled,
  onClick,
  onMouseEnter,
  onMouseLeave,
  style,
  type,
  ref,
}) {
  const _onClick = (...args) => {
    if (onClick) {
      onClick(...args);
    }
  };
  return (
    <button
      children={children}
      ref={ref}
      className={twMerge('border-0 outline-0 p-0 bg-transparent cursor-pointer text-inherit text-left block disabled:cursor-not-allowed', className)}
      disabled={disabled}
      onClick={_onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={style}
      type={type}
    />
  );
}
